import { useMemo } from 'react'

import { ANYWHERE_PLACE_ID } from 'constants/search'
import Places from 'constants/places'
import { EmptyArray } from 'lib/array/arrayUtils'
import { usePlacesAncestorsById } from 'hooks/usePlace'

/**
 * True when hotel search is scoped to Bali or a place whose ancestors include Bali
 * (e.g. Seminyak, Ubud). False while ancestor data is still loading for sub-places.
 */
export function useIsBaliHotelSearchRegion(destinationId: string | undefined): boolean {
  const needsBaliAncestorCheck = Boolean(
    destinationId && destinationId !== ANYWHERE_PLACE_ID && destinationId !== Places.Bali.id,
  )
  const placeIdsForAncestors = useMemo<Array<string>>(() => {
    if (needsBaliAncestorCheck && destinationId) {
      return [destinationId]
    }
    return EmptyArray
  }, [needsBaliAncestorCheck, destinationId])
  const [ancestorsLists, fetchingLists] = usePlacesAncestorsById(placeIdsForAncestors)
  const baliRegionAncestorIds = ancestorsLists[0] ?? EmptyArray
  const fetchingBaliAncestors = fetchingLists[0] ?? false

  return useMemo(() => {
    if (!destinationId || destinationId === ANYWHERE_PLACE_ID) {
      return false
    }
    if (destinationId === Places.Bali.id) {
      return true
    }
    if (needsBaliAncestorCheck && fetchingBaliAncestors) {
      return false
    }
    return baliRegionAncestorIds.includes(Places.Bali.id)
  }, [baliRegionAncestorIds, destinationId, fetchingBaliAncestors, needsBaliAncestorCheck])
}
